import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import Divider from 'material-ui/Divider';
import Panel from 'panelComponents/Panel';
import WorkOrderCard from 'workOrderComponents/WorkOrderCard';
import CustomerHistory from 'accountComponents/CustomerHistory';
class WorkOrderCardPanel extends PureComponent {

    componentDidUpdate() {}

    render() {
        // eslint-disable-next-line react/prop-types
        const {workOrderActions, orderDetail, orderId, header, detailKey, techId, billingSystem, customerDetail} = this.props;
        
        let customerHistory = null;
        if(customerDetail){
            customerHistory =  <CustomerHistory
                       orderDetail={orderDetail}
                       orderId={orderId}
                       workOrderActions={workOrderActions} />;
        }
        return (

            <Panel
                loading={false}
                hasDetails={true}
                orderId={orderId}
                detailKey={detailKey}
                header={header}
                hideHeader>
                <div
                    style={{
                    border: 'solid 1px #e0e0e0',
                    ...(!customerDetail ? {overflow: 'hidden'} : null)
                }}>
                      <WorkOrderCard workOrderActions={workOrderActions} workOrder={orderDetail} techId={techId} billingSystem={billingSystem} customerDetail={customerDetail} orderId={orderId}/>
                </div>
                {customerDetail && <Divider />}
                {customerHistory}
            </Panel>
        );
    }
}

WorkOrderCardPanel.propTypes = {
    workOrderActions: PropTypes.object,
    orderDetail: PropTypes.object,
    orderId: PropTypes.string,
    header: PropTypes.string,
    detailKey: PropTypes.string,
    techId: PropTypes.string
};

WorkOrderCardPanel.contextTypes = {
};

export default WorkOrderCardPanel;



// WEBPACK FOOTER //
// ./src/components/work-order/WorkOrderCardPanel.js